import React, { useEffect } from "react"
import { useProjectDataStore } from "@state/projectDataStore"
import styled from "styled-components"

import { useAngles } from "./hooks/useAngles"
import ViewUI from "./components/ViewLayout"
import ViewList from "./components/ViewList"
import { useCanvasStore } from "@state/canvasStore"
import LabelUI from "./components/LabelUI"
import { ROUTE_CAM_POSITIONS } from "@data/cameraData"
import InfoLayout from "../Info1/components/InfoLayout"
import { info2Data } from "../Info2/info2Data"

const Orbit3D = () => {
  const { orbitData } = useProjectDataStore((s) => ({
    orbitData: s.orbitData,
  }))

  const { info1Data } = useProjectDataStore((s) => ({
    info1Data: s.info1Data,
  }))

  const setCameraData = useCanvasStore((s) => s.setCameraData)

  useEffect(() => {
    // console.log("newcam:", ROUTE_CAM_POSITIONS["/orbits"].position)
    setCameraData(ROUTE_CAM_POSITIONS["/orbits"])
  }, [])

  const touchPoints = orbitData.touchPoints

  const setTouchPoints = useCanvasStore((s) => s.setTouchPoints)

  React.useEffect(() => {
    setTouchPoints(touchPoints)
  }, [touchPoints])

  const { angleUI, pointsMapped } = useAngles()

  if (!pointsMapped) return null

  // console.log(info1Data)

  return (
    <Wrapper>
      {/* <ViewList pointsMapped={pointsMapped} /> */}
      {/* <ViewUI pointsMapped={pointsMapped} /> */}
      {/* <LabelUI /> */}
      {/* <Angle ref={angleUI} /> */}
      <InfoLayout className="first" info1Data={info2Data?.sections[2]} />
    </Wrapper>
  )
}

const Angle = styled.div`
  z-index: 2;
  top: 20px;
  right: 50%;
  transform: translateX(50%);
  color: white;

  position: absolute;
  width: 50px;
  height: 50px;
`

const Wrapper = styled.div`
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;

  .filterIcon {
    position: absolute;
    border-radius: 100%;
    right: 4.5rem;
    margin: 2rem;
    border: 1px solid var(--accent);
  }
`

export default Orbit3D
